import styles from './BarChart.module.css';
import { STATUS_FILL, type ChartDatum } from './chart-colors';

export interface BarChartProps {
  readonly data: readonly ChartDatum[];
  readonly title: string;
  /** Defaults to the largest value so bars fill the available width. */
  readonly max?: number;
}

/**
 * Horizontal status bars. Every bar is directly labelled with its name and
 * value, so the encoding survives both colour-vision deficiency and print.
 */
export function BarChart({ data, title, max }: BarChartProps) {
  const ceiling = max ?? Math.max(...data.map((d) => d.value), 1);

  return (
    <div className={styles.list} role="img" aria-label={title}>
      {data.map((datum) => {
        const pct = ceiling > 0 ? Math.round((datum.value / ceiling) * 100) : 0;
        return (
          <div key={datum.label} className={styles.row}>
            <div className={styles.head}>
              <span className={styles.label}>{datum.label}</span>
              <span className={styles.value}>{datum.value}</span>
            </div>
            <div className={styles.track}>
              <div
                className={styles.fill}
                style={{ width: `${pct}%`, background: STATUS_FILL[datum.tone] }}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
}
